import { Component, EventEmitter, Output } from '@angular/core';
import { ReportModalComponent } from '../../../../@modals/report-modal/report-modal.component';
import { FlagIconComponent } from '../../../../../@icons/flag-icon.component';
import { SharedModule } from '../../../../ui-components/shared.module';
import { InfoIconComponent } from '../../../../../@icons/info-icon.component';
import { SquarePenIconComponent } from '../../../../../@icons/square-pen-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AiChatbotInfoModalComponent } from '../ai-chatbot-info-modal/ai-chatbot-info-modal.component';

@Component({
    selector: 'vw-ai-chatbot-header',
    imports: [ReportModalComponent, FlagIconComponent, SharedModule, InfoIconComponent, SquarePenIconComponent, TranslateModule, CommonModule, AiChatbotInfoModalComponent],
    templateUrl: './ai-chatbot-header.component.html',
    styleUrl: './ai-chatbot-header.component.scss'
})
export class AiChatbotHeaderComponent {
  @Output() newConversation = new EventEmitter<void>();

  showReportPopup: boolean = false;
  showInfoPopup: boolean = false;
  isReported: boolean = false;

  onNewConversationClick() {
    this.newConversation.emit();
  }

  onFlagClick() {
    this.showReportPopup = true;
  }

  onReport() {
    // TODO: Send report to backend?
    this.isReported = true;
  }

  onInfoClick() {
    this.showInfoPopup = true;
  }

  onInfoModalClose() {
    this.showInfoPopup = false;
  }
}
